import {
  AsyncPipe,
  NgClass,
  NgTemplateOutlet,
  TitleCasePipe,
  UpperCasePipe,
} from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  TemplateRef,
  output,
  inject,
  ChangeDetectorRef,
  input,
  viewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  COMPANY_INFO,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject, map, Observable, of, Subject } from 'rxjs';

import { ChipModule } from 'primeng/chip';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InplaceModule } from 'primeng/inplace';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import { ErrorsComponent } from '@fitness-force/errors';
import { TaskOpportunityInfoComponent } from '@fitness-force/crm';
import { LostDealComponent } from '@fitness-force/crm';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import { ErrorMsgComponent } from '@fitness-force/errors';
import type {
  CreateFollowupTaskByDateRequest,
  CreateLogTourNotesRequest,
  CreateTourOutcomeRequest,
} from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import type {
  PlanSummary,
  PlanSummaryClient,
  PlanSummaryCRM,
  STAGE_MASTER_MODEL,
  TENANTSINTERFACE,
  ValidationError,
} from '@fitness-force/models';
import {
  ClientService,
  TaskCallOutcomeService,
  TimeconversionService,
} from '@fitness-force/api';
import { ToastMessageService } from '@fitness-force/api';

import { BillingComponent } from '@fitness-force/billing';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';
import { TourOutcome } from '@fitness-force/enum';

@Component({
  selector: 'app-tour-outcome',
  templateUrl: './tour-outcome.component.html',
  styleUrls: ['./tour-outcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    ChipModule,
    InplaceModule,
    TaskOpportunityInfoComponent,
    DatePickerModule,
    ToggleSwitchModule,
    StyleClassModule,
    ErrorMsgComponent,
    TabsModule,
    ErrorMsgComponent,
    ErrorsComponent,
    BillingComponent,
    LostDealComponent,
    ShortNamePipe,
    AvatarModule,
    TranslateModule,
    AsyncPipe,
    NgClass,
    NgTemplateOutlet,
    TitleCasePipe,
    UpperCasePipe,
  ],
})
export class TourOutcomeComponent implements OnInit {
  store = inject(Store);
  translate = inject(TranslateService);
  private fb = inject(UntypedFormBuilder);
  private tourOutcomeService = inject(TaskCallOutcomeService);
  private timeService = inject(TimeconversionService);
  private toastMessageService = inject(ToastMessageService);
  private clientService = inject(ClientService);
  private cd = inject(ChangeDetectorRef);

  readonly showMeetingOutcome = input(false, { alias: 'visible' });
  readonly modelData = input<any>(undefined, { alias: 'tourOutComeData' });
  readonly hideOutCome = output<any>();

  localModelData: any = undefined;
  readonly modified = output<boolean>();

  readonly notintrestedform = viewChild<TemplateRef<any> | any>('notintrested');
  readonly noshowform = viewChild<TemplateRef<any> | any>('noshow');
  readonly rescheduleform = viewChild<TemplateRef<any> | any>('reschedule');
  readonly stillthinkingform = viewChild<TemplateRef<any> | any>(
    'stillthinking',
  );

  readonly showClientProfile = output<any>();

  frmgroupCreateTourOutCome: UntypedFormGroup;
  TourOutComeNotIntrestedForm: UntypedFormGroup;
  TourOutComeStillThinkingForm: UntypedFormGroup;
  TourOutComeNoShowForm: UntypedFormGroup;
  TourOutComeRescheduleForm: UntypedFormGroup;

  public companyInfoDetail$!: Observable<any>;

  companyDetails: any;
  convertibility: any = CONSTANTS_CRM.OPPORTUNITY_CONVERTITBILITY;
  selectedConvertibility!: any;
  outcome: any = CONSTANTS_CRM.TOUR_OUTCOME;
  values: string[] | undefined;
  followUpDate: Date | undefined;
  contractEndDate: Date | undefined;
  mylookupservice: any;
  selectedOutcome!: any;
  markcompletedchecked: boolean = false;
  showCalender: Observable<boolean> | any = false;
  selectedOutcomeTemplate: any;
  selectedDateTime: Date | any;
  selectedTime: string | any;
  errMsg: Error | any;
  tenantId: number | any;
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  errorDataModalSubject = new BehaviorSubject([] as ValidationError[]);
  errorDataModal = [] as ValidationError[];

  //#region billing sidebar
  planSummarydataObject$: BehaviorSubject<PlanSummary> = new BehaviorSubject(
    {} as PlanSummary,
  );
  showPaidFullSidebar: boolean = false;
  //#endregion billing sidebar

  showChooseReason: boolean = false;
  showLostDealDialog = false;
  lostDealItemInfo = '';
  stageMaster$: Observable<any> = new Subject();

  showClientSidebar = false;
  activeClientId = 0;
  clientData: any;

  ngOnInit(): void {
    this.TourOutComeNotIntrestedForm = this.fb.group({
      comments: ['', [Validators.required]],
    });

    this.TourOutComeStillThinkingForm = this.fb.group({
      comments: ['', [Validators.required]],
    });

    this.TourOutComeNoShowForm = this.fb.group({
      comments: ['', [Validators.required]],
    });

    this.TourOutComeRescheduleForm = this.fb.group({
      rescheduleDate: ['', [Validators.required]],
      followupTime: ['', [Validators.required]],
      comments: ['', [Validators.required]],
      // ,
      // taskcompleted: [this.markcompletedchecked]
    });
    this.componentInit();
    this.setNoshowFormControlValidator();
  }

  componentInit() {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.companyDetails = responseData;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    const modelData = this.modelData();
    if (modelData?.client_info) {
      this.clientService.getClientById(modelData.client_info.id).subscribe({
        next: (res: any) => {
          this.clientData = res;
        },
        error: () => {
          //
        },
      });
    }

    this.stageMaster$ = this.store.select(STAGE_MASTER_STATE);
  }

  MarkTourOutComeNotIntrested(formdata: UntypedFormGroup) {
    this.TourOutComeNotIntrestedForm.markAllAsTouched();

    if (!this.TourOutComeNotIntrestedForm.valid) {
      return;
    }

    const createTourOutcomeRequest: CreateTourOutcomeRequest =
      {} as CreateTourOutcomeRequest;
    const logTour = {} as CreateLogTourNotesRequest;
    logTour.transaction_notes = formdata.value.comments;
    logTour.staff_id = this.modelData().assigned_to_staff_id;
    logTour.transaction_log_date = new Date().toISOString();
    createTourOutcomeRequest.tour_outcome = TourOutcome.NotInterested;
    createTourOutcomeRequest.mark_as_complete = true;
    createTourOutcomeRequest.book_trial = null;
    createTourOutcomeRequest.log_tour = logTour;

    this.CreateTourOutCome(createTourOutcomeRequest, formdata);
  }

  MarkTourOutComeNoShow(formdata: UntypedFormGroup) {
    this.TourOutComeNoShowForm.markAllAsTouched();
    if (!this.TourOutComeNoShowForm.valid) {
      return;
    }

    const createTourOutcomeRequest: CreateTourOutcomeRequest =
      {} as CreateTourOutcomeRequest;
    const logTour = {} as CreateLogTourNotesRequest;
    logTour.transaction_notes = formdata.value.comments;
    logTour.staff_id = this.modelData().assigned_to_staff_id;
    logTour.transaction_log_date = new Date().toISOString();
    createTourOutcomeRequest.tour_outcome = TourOutcome.NoShow;
    createTourOutcomeRequest.mark_as_complete = true;
    createTourOutcomeRequest.book_trial = null;
    createTourOutcomeRequest.log_tour = logTour;
    this.CreateTourOutCome(createTourOutcomeRequest, formdata);
  }

  RescheduleTouroutcome(formdata: UntypedFormGroup) {
    this.TourOutComeRescheduleForm.markAllAsTouched();
    if (!this.TourOutComeRescheduleForm.valid) {
      return;
    }

    const createTourOutcomeRequest: CreateTourOutcomeRequest =
      {} as CreateTourOutcomeRequest;
    const scheduleTask = {} as CreateFollowupTaskByDateRequest;
    if (formdata.value.rescheduleDate)
      scheduleTask.scheduled_datetime =
        this.timeService.GetUTCDateTimeByDateAndTime(
          formdata.value.rescheduleDate,
          formdata.value.followupTime,
        );

    const logTour = {} as CreateLogTourNotesRequest;
    logTour.transaction_notes = formdata.value.comments;
    logTour.staff_id = this.modelData().assigned_to_staff_id;
    logTour.transaction_log_date = new Date().toISOString();
    createTourOutcomeRequest.tour_outcome = TourOutcome.Reschedule;
    createTourOutcomeRequest.mark_as_complete = this.markcompletedchecked;
    createTourOutcomeRequest.reschedule_task = scheduleTask;
    createTourOutcomeRequest.log_tour = logTour;
    this.CreateTourOutCome(createTourOutcomeRequest, formdata);
  }

  MarkTourOutComeStillThinking(formdata: UntypedFormGroup) {
    this.TourOutComeStillThinkingForm.markAllAsTouched();
    if (!this.TourOutComeStillThinkingForm.valid) {
      return;
    }

    const createTourOutcomeRequest: CreateTourOutcomeRequest =
      {} as CreateTourOutcomeRequest;
    const logTour = {} as CreateLogTourNotesRequest;
    logTour.transaction_notes = formdata.value.comments;
    logTour.staff_id = this.modelData().assigned_to_staff_id;
    logTour.transaction_log_date = new Date().toISOString();
    createTourOutcomeRequest.tour_outcome = TourOutcome.StillThinking;
    createTourOutcomeRequest.mark_as_complete = true;
    createTourOutcomeRequest.book_trial = null;
    createTourOutcomeRequest.log_tour = logTour;

    this.CreateTourOutCome(createTourOutcomeRequest, formdata);
  }

  CreateTourOutCome(
    createTourOutcomeRequest: CreateTourOutcomeRequest,
    formdata: UntypedFormGroup,
  ) {
    this.tourOutcomeService
      .createTourOutcome(
        this.tenantId,
        this.modelData().latest_task.id,
        createTourOutcomeRequest,
      )
      .subscribe({
        next: async () => {
          this.translate
            .get('OUTCOME.MESSGES.TASK_SUCCESS_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          await this.timeout(1000);
          //Show Opportunity loss floe on Popup , also will not open for opportunity
          const modelData = this.modelData();
          if (
            createTourOutcomeRequest.tour_outcome ==
              TourOutcome.NotInterested &&
            modelData.stage_master_id
          ) {
            this.lostDealItemInfo = modelData;
            this.showChooseReason = true;
            this.cd.detectChanges();
          } else {
            this.ClearForm(formdata);
            this.setHidePopup(true);
          }
        },
        error: (error: AppErrors) => {
          if (error instanceof NotFoundError) {
            this.errMsg = error.originalError.message;
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error.errorMessage);
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
              this.cd.detectChanges();
            }
          }
          this.cd.detectChanges();
        },
      });
  }

  ClearForm(formName: UntypedFormGroup) {
    this.hideOutCome.emit({ showPopup: false, modified: false });
    this.selectedOutcome = null;
    this.selectedOutcomeTemplate = null;
    formName.reset();
  }

  setHidePopup(modified: boolean = false) {
    this.hideOutCome.emit({ showPopup: false, modified: false });
    this.hideOutCome.emit({ showPopup: this.showMeetingOutcome(), modified });
    this.selectedOutcome = null;
    this.TourOutComeNoShowForm.reset();
    this.TourOutComeRescheduleForm.reset();
    this.TourOutComeNotIntrestedForm.reset();
    this.cd.detectChanges();
  }

  SelectOutcome(item: any) {
    this.selectedOutcome = item;
    if (item.shortname == 'noshow') {
      this.selectedOutcomeTemplate = this.noshowform();
      this.TourOutComeNoShowForm.reset();
    }
    if (item.shortname == 'notintrested') {
      this.selectedOutcomeTemplate = this.notintrestedform();
      this.TourOutComeNotIntrestedForm.reset();
    }
    if (item.shortname == 'reschedule') {
      this.selectedOutcomeTemplate = this.rescheduleform();
      this.TourOutComeRescheduleForm.reset();
    }
    if (item.shortname == 'stillthinking') {
      this.selectedOutcomeTemplate = this.stillthinkingform();
      this.TourOutComeStillThinkingForm.reset();
    }
    if (item.shortname == 'signup') {
      // this.selectedOutcomeTemplate = this.signupform;
      const draggedProduct = this.modelData();
      const planSummary: PlanSummary = {
        id: 0,
        from_subscription_id: 0,
        client: {
          client_id: draggedProduct.client_info.id,
          client_name: draggedProduct.client_info.full_name,
          client_status: draggedProduct.client_info.status,
        } as PlanSummaryClient,
        couponcode: null,
        tenant_id: this.tenantId,
        company_id: draggedProduct.company_id,
        startdate: new Date(),
        plan_selectable: true,
        CRM: {
          opp_id: draggedProduct.id,
          task_id: draggedProduct.latest_task?.id || 0,
          board_id: draggedProduct.board_type,
        } as PlanSummaryCRM,
        Scheduling: null,
      } as PlanSummary;

      this.planSummarydataObject$.next(planSummary);
      this.showPaidFullSidebar = true;
    }
  }

  hideBillingSummary(event: any) {
    this.showPaidFullSidebar = false;
    this.planSummarydataObject$.next({} as PlanSummary);
    if (event.uuid && String(event.uuid).trim() != '') {
      this.setHidePopup(true);
    }
  }

  SelectOutcomeMob(item: any) {
    this.SelectOutcome(item.value);
  }

  clickMarkcompletedChecked(e: any) {
    this.markcompletedchecked = e.checked;
  }

  setNoshowFormControlValidator() {
    // this.TourOutComeRescheduleForm.controls.taskcompleted.valueChanges.subscribe(
    //   (value: boolean) => {
    //     let rescheduleDateFormcontrol = this.TourOutComeRescheduleForm.controls.rescheduleDate as FormControl;
    //     let followupTimeFormcontrol = this.TourOutComeRescheduleForm.controls.followupTime as FormControl;
    //     if (value) {
    //       rescheduleDateFormcontrol.setValidators(null);
    //       followupTimeFormcontrol.setValidators(null);
    //       rescheduleDateFormcontrol.setValue('');
    //       followupTimeFormcontrol.setValue('');
    //       rescheduleDateFormcontrol.disable();
    //       followupTimeFormcontrol.disable();
    //     } else {
    //       rescheduleDateFormcontrol.setValidators([Validators.required]);
    //       followupTimeFormcontrol.setValidators([Validators.required]);
    //       rescheduleDateFormcontrol.enable();
    //       followupTimeFormcontrol.enable();
    //     }
    //   }
    // );
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
    this.cd.detectChanges();
  }

  GetErrorData(event: any) {
    this.errorMessages = event.errors;
    this.showErrorPopup?.next(event.showErrors);
    this.cd.detectChanges();
  }

  get ShowErrorPopup(): Observable<boolean> {
    return this.showErrorPopup?.asObservable() || of(false);
  }

  GetUpdatedData(event: any) {
    this.localModelData = event;
    this.modified.emit(true);
    this.cd.detectChanges();
  }

  get getoutcome(): any {
    return this.selectedOutcomeTemplate;
  }

  get SelectedConvertibility(): UntypedFormControl {
    return this.frmgroupCreateTourOutCome.controls
      .ddlConvertibility as UntypedFormControl;
  }

  closeDailog() {
    this.showChooseReason = false;
    this.showLostDealDialog = false;
    // This was not inserted here
    this.setHidePopup(true);
    this.cd.detectChanges();
  }

  OpenLostDeal(modalData: any) {
    this.showChooseReason = true;
    this.lostDealItemInfo = modalData;
    this.cd.detectChanges();
  }

  clientStatus(client: any): string {
    if (client && client.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else return '';
  }

  getStageStatus(stageMasterid: number): Observable<string | undefined> {
    return this.store
      .select(STAGE_MASTER_STATE)
      .pipe(
        map(
          (value: STAGE_MASTER_MODEL[]) =>
            value.find((obj) => obj.id == stageMasterid)?.name_primary_language,
        ),
      );
  }

  goToClientProfile(clientId: number) {
    this.activeClientId = this.modelData().client_info.id;
    this.showClientProfile.emit({ clientId: this.activeClientId });
  }

  GoToClientDetails(event: any) {
    this.showPaidFullSidebar = false;
    this.activeClientId = this.modelData().client_info.id;
    this.setHidePopup(true);
    this.showClientProfile.emit({ clientId: this.activeClientId });
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
